import api from "./httpService";

type CreateAssignmentPayload = {
    coachId: string;
    memberId: string;
};

const toArray = (value: unknown): unknown[] => {
    if (Array.isArray(value)) return value;
    if (value && typeof value === "object") {
        const data = value as { data?: unknown; items?: unknown; assignments?: unknown };
        if (Array.isArray(data.data)) return data.data;
        if (Array.isArray(data.items)) return data.items;
        if (Array.isArray(data.assignments)) return data.assignments;
    }
    return [];
};

export const getAssignments = async () => {
    const response = await api.get("/assign");
    return toArray(response.data);
};

export const createAssignment = async (payload: CreateAssignmentPayload) => {
    const response = await api.post("/assign", payload);
    return response.data;
};
